import { Sparkles } from "lucide-react";

/** Investment summary card on the report page. */
export function ReportSummary({ summary }) {
  if (!summary) return null;
  return (
    <div className="rounded-xl border border-kira-border bg-kira-surface p-6 mb-6">
      <div className="flex items-center gap-2 mb-3">
        <Sparkles className="h-4 w-4 text-kira-gold" />
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-kira-gold">
          Investment Summary
        </p>
      </div>
      <p className="text-kira-textMuted leading-relaxed whitespace-pre-wrap">{summary}</p>
    </div>
  );
}
